'use client'

import Link from 'next/link'
import { Topbar } from '@/components/Topbar'
import { Footer } from '@/components/Footer'

export default function Error({
  unstable_retry,
}: {
  error: Error & { digest?: string }
  unstable_retry: () => void
}) {
  return (
    <div>
      <Topbar />
      <main className="page">
        <section style={{ padding: '120px 0 160px', textAlign: 'center' }}>
          <div className="container" style={{ maxWidth: 560 }}>
            <div style={{
              fontFamily: 'var(--mono)',
              fontSize: 11,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              color: 'var(--clay-text)',
              marginBottom: 24,
            }}>
              Fout
            </div>
            <h1 className="section-title" style={{ marginBottom: 16 }}>Er ging iets mis</h1>
            <p className="section-sub" style={{ marginBottom: 40 }}>
              Er is een onverwachte fout opgetreden. Probeer het opnieuw of ga terug naar de homepage.
            </p>
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button className="btn btn-primary" onClick={unstable_retry}>
                Opnieuw proberen
              </button>
              <Link href="/" className="btn btn-secondary">Naar de homepage</Link>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </div>
  )
}
